import { combineReducers } from "redux";
import customerReducer from "./CustomerReducer";
import accessControlReducer from "./AccessControlReducer";
import authReducer from "./AuthReducer";
import productReducer from "./ProductReducer";
import categoryReducer from "./CategoryReducer";
import ordersReducer from "./OrderReducer";
import agentManagement from "./AgentManagementReducer";
import storeListingReducer from "./StoreListingReducer";
import shipperReducer from "./ShipperReducer";
import bannerReducer from "./BannerReducer";
import productCityLevelReducer from "./ProductCityLevelReducer";
import categoryGlobalReducer from "./CategoryGlobalReducer";
import zoneReducer from "./ZoneReducer";
import riderManagementReducer from "./RiderManagementReducer";
import promosCityLevelReducer from "./PromoCityLevelReducer";
import warehouseOpsReducer from "./WarehouseOpsReducer";
import campaignReducer from "./CampaignReducer";
import zonalConfigsReducer from "./ZonalConfigReducer";
import CnicVerificationReducer from "./CnicVerificationReducer";
import WarehouseStaffReducer from "./WarehouseStaffReducer"
import deliveryDateReducer from "./DeliveryDateReducer";
import metricsReducer from "./MetricsReducer";
import paiyaConfigReducer from "./PaiyaConfigReducer";
import newsfeedReducer from "./NewsfeedReducer";
import liveopsReducer from "./LiveopsReducer";
import agentAssignmentReducer from "./AgentAssignmentReducer";
import paiyaGiftReducer from "./PaiyaGiftReducer";

const rootReducer = combineReducers({
  customer: customerReducer,
  accessControlUser: accessControlReducer,
  userAuth: authReducer,
  product: productReducer,
  category: categoryReducer,
  orders: ordersReducer,
  agentManagement: agentManagement,
  storeListing: storeListingReducer,
  shipper: shipperReducer,
  banner: bannerReducer,
  productCityLevel: productCityLevelReducer,
  categoryGlobal: categoryGlobalReducer,
  zone: zoneReducer,
  riderManagement: riderManagementReducer,
  promosCityLevel: promosCityLevelReducer,
  warehouseOps: warehouseOpsReducer,
  campaign: campaignReducer,
  zonalConfigs: zonalConfigsReducer,
  cnicVerification: CnicVerificationReducer,
  warehouseStaff: WarehouseStaffReducer,
  deliveryDate: deliveryDateReducer,
  liveops: liveopsReducer,
  metrics: metricsReducer,
  paiyaConfig: paiyaConfigReducer,
  newsfeeds: newsfeedReducer,
  agentAssignment: agentAssignmentReducer,
  paiyaGift: paiyaGiftReducer
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
